import Enum from "@shared/enum.js";

export default {
	"casino": {
		"viewId": Enum.Views.MAIN,
		"path": [
			"4sg,sky:casino/4stars/casino",
			"fund,fundsky:casino/fund/casino",
		],
		"expectingGames": true
	},
	"page-not-found": {
		"viewId": Enum.Views.PAGE_NOT_FOUND,
		"path": [
			"4sg,sky:page-not-found/page-not-found-4stars",
			"fund,fundsky:page-not-found/page-not-found-fund",
		],
		"expectingGames": false
	},
	"no-support-cy": {
		"viewId": Enum.Views.NO_SUPPORT_CY,
		"path": [
			"no-support/no-support-[site-key]"
		],
		"expectingGames": false
	},
	"no-support": {
		"viewId": Enum.Views.NO_SUPPORT,
		"path": [
			"no-support/no-support-[site-key]"
		],
		"expectingGames": false
	},
	"blog": {
		"viewId": Enum.Views.BLOG,
		"path": [
			"blog/blog"
		],
		"expectingGames": true
	},
	"web-res-tc": {
		"viewId": Enum.Views.TC,
		"path": [
			"webres-presenter"
		],
		"expectingGames": false
	},
	"web-res-btc": {
		"viewId": Enum.Views.BTC,
		"path": [
			"webres-presenter"
		],
		"expectingGames": false
	},
	"web-res-ft": {
		"viewId": Enum.Views.FREE_BET,
		"path": [
			"webres-presenter"
		],
		"expectingGames": false
	},
	"cashier": {
		"viewId": Enum.Views.CASHIER,
		"path": [
			"empty-page"
		],
		"expectingGames": false
	},
	"playstore-redirect": {
		"viewId": Enum.Views.PLAYSTORE_REDIRECT,
		"path": [
			"playstore-redirect"
		],
		"expectingGames": false
	},
	"vccp-register-sigma": {
		"viewId": Enum.Views.VCCP_REGISTER_SIGMA,
		"path": [
			"vccp-register-sigma/vccp-register-sigma"
		],
		"expectingGames": false
	},
	"vccp-register-sky": {
		"viewId": Enum.Views.VCCP_REGISTER_SKY,
		"path": [
			"vccp-register-sky/vccp-register-sky"
		],
		"expectingGames": false
	},
}